import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 4px;
  padding: 32px 32px 0 32px;
  max-width: 500px;
`
export const Title = styled.h1`
  font-weight: ${({ theme }) => theme.font.bold};
  font-size: ${({ theme }) => theme.font.sizes.large};
  color: ${({ theme }) => theme.ds.colors.neutral800};
`

export const Subtitle = styled.span`
  font-weight: ${({ theme }) => theme.font.normal};
  font-size: ${({ theme }) => theme.font.sizes.medium};
  color: ${({ theme }) => theme.ds.colors.neutral800};
  text-align: center;
`
export const ImageContainer = styled.div`
  margin-top: 40px;
  margin-bottom: 40px;
`

export const ButtonContainer = styled.div`
  padding: 0 32px 32px 32px;
  text-align: right;
`
